<div
  class="app__template--manage--owners--dialog w-[750px] max-[480px]:w-screen rounded-xl"
  [class]="inlineComponent ? 'px-2 mt-2' : 'h-[600px] px-6 py-8'"
>
  <div class="flex justify-between">
    <span class="relative text-center m-0" [ngClass]="{ 'left-3': !inlineComponent }" style="width: -webkit-fill-available">
      <span class="block">
        <p class="app__form--attribute--title text-2xl leading-9 text-center">Manage Permissions</p>
        <p class="app__form--attribute--title font-normal text-sm text-[#515765] text-center mt-[-10px]">
          Manage permissions for {{ data?.fileFolderName }}
        </p>
      </span>
    </span>

    <button class="close" type="button" data-dismiss="modal" (click)="closeDialog()">
      <span class="material-icons relative text-[30px] text-[#707070] font-semibold leading-9">close </span>
    </button>
  </div>

  <div class="flex items-center flex-col w-full h-full" [ngClass]="{ 'px-7': !inlineComponent }">
    @if (!showLoader) {
    <div class="w-full">
      <ng-container>
        <manage-users
          [data]="users"
          [isAccessManager]="true"
          [isInputFullWidth]="true"
          [placeHolder]="'Search your network'"
          [selectedUsers]="existingUsers"
          (selectConnectedUser)="selectConnectedUser($event)"
        ></manage-users>
      </ng-container>
    </div>
    } @if ((!existingUsers || existingUsers?.length === 0 ) && (!sharedUsers || sharedUsers?.length === 0)) {
    <div class="app__centered-item text-center w-full mt-8">
      @if (!showLoader) {
      <span class="app__centered-item" [class]="!inlineComponent ? 'h-[65%]' : 'h-[320px]'">
        <span>
          <img [src]="'assets/images/no-permission.svg'" />
          <p class="app__form--attribute--title text-center text-lg font-semibold text-[#53565B] mt-2">
            No Permissions to show
          </p>
        </span>
      </span>
      } @if (showLoader) {
      <span class="w-full mt-2">
        <div class="ph-item w-full bg-transparent border-none m-0 p-0">
          <div class="ph-col-12 p-0">
            <div class="ph-row p-0">
              <div class="ph-col-12 h-[58px] rounded-[10px]" style="height: 58px"></div>
            </div>
            <div class="ph-row mt-6">
              <div class="ph-col-4 h-[12px] rounded-[10px]" style="height: 12px"></div>
            </div>
            @for (item of [{}, {}, {}, {}]; track item) {
            <div class="app__centered-item w-full h-[64px] justify-between">
              <div class="ph-item w-full border-none m-0 p-0">
                <div class="ph-col-12 p-0">
                  <div class="ph-row mt-3">
                    <div style="margin-right: 10px; min-width: auto" class="ph-avatar flex fl-al-center w-8 h-8 ph-col-1"></div>
                    <div class="ph-col-10"></div>
                    <div class="ph-col-10 mt-[-12px] ml-[42px]"></div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </span>
      }
    </div>
    } @if (existingUsers?.length) {
    <div class="w-full mt-3" [class]="!inlineComponent ? (data?.showMarkAsComplete ? 'h-[62%] max-h-[62%]' : 'h-[75%] max-h-[75%]') : 'max-h-[75%]'">
      <div class="app__centered-item justify-between w-full">
        <p class="app__centered-item app__form--attribute--title text-base font-semibold">
          Permissions
          <span class="text-[#25508E] font-bold ml-1"> ({{ existingUsers?.length }}) </span>
        </p>
      </div>
      <div
        class="flex flex-wrap w-full overflow-y-auto gap-3"
        [ngClass]="{ 'max-h-[82%] px-2': !inlineComponent, 'max-h-[92%] pr-2': inlineComponent }"
      >
        @for (existingUser of existingUsers; track existingUser; let i = $index) {
        <span class="app__discovery--selected--option overflow-y-hidden">
          <ngx-avatars
            class="custom-nx-avatar"
            size="52"
            [src]="existingUser?.profile_image_url ?? existingUser?.form_profile_image_url ?? existingUser?.user_profile_image_url"
            [name]="existingUser?.name | titlecase"
            [round]="true"
            initialsSize="2"
            cornerRadius="100"
          ></ngx-avatars>
          <span
            class="app__form--attribute--title w-[84%] block"
            [class]="existingUser.relationship_name ? 'mt-6' : 'mt-0'"
            [matTooltip]="existingUser?.name.length > 34 ? existingUser.name : ''"
            matTooltipPosition="above"
          >
            <div style="margin-bottom: 1rem;" class="flex text-sm font-semibold">
              <div class="name-ellipsis" appTooltip [toolTipText]="existingUser?.name | capitalizeRomanNumerals">{{ existingUser?.name | capitalizeRomanNumerals }}</div>
              <span>
                @if (existingUser?.connection_status == 'pending') {
                <span class="d-flex relatinoship-title text-truncate">
                  <mat-icon style="font-size: 16px; position: relative; top: 2px; margin: 0px; left: 8px">check_circle</mat-icon>&nbsp;
                  {{ existingUser.from_user_id == currentUser?.id ? ' Network request sent ' : ' Network request received ' }}
                </span>
                } @if (existingUser?.connection_status == 'invited') {
                <span class="d-flex relatinoship-title text-truncate">
                  <mat-icon style="font-size: 16px; position: relative; top: 2px; margin: 0px; left: 8px">check_circle</mat-icon> &nbsp; Invite sent
                </span>
                }</span
              >
              </div>
            @if(existingUser?.relationship_name){
            <p class="font-medium text-[12px] text-[#707070] mt-[-23px]">{{ existingUser?.relationship_name }}</p>
            }
          </span>

          <div class="app__centered-item justify-end">
            <div class="flex gap-1 justify-center items-center">
              @if(existingUser?.owner_type && existingUser?.owner_type != 'share'){
              <div
                class="mt-2 flex justify-center items-center bg-[#EBF0FA] border border-[#25508E] h-6 w-fit rounded-[4px] py-[2px] px-2 text-[#25508E] text-[10px] leading-none font-normal"
              >
                {{ existingUser?.owner_type | titlecase }}
              </div>
              } @if((existingUser?.owner_type == 'creator' && existingUser.type == 'OWNER') || existingUser?.userId === currentUser.id){
              <div class="h-[48px] w-[48px]"></div>
              } @if (((existingUser.type == 'OWNER' || existingUser.owner_type === 'owner') && existingUser?.owner_type != 'creator' && existingUser?.userId !== currentUser.id)) {
              <div class="shareTypeSelection">
                <span class="app__centered-item">
                  <button mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true">
                    <span class="material-icons text-[#25508e]">more_vert</span>
                  </button>
                  <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                    <button mat-menu-item class="popup-menu-item remove-link text-[#ff0000]" (click)="deletpermission(existingUser)">
                      <span class="material-icons menuitem-icon text-base text-[#ff0000]">delete</span>
                      <span class="relative top-[-3px] left-[2px]"> Remove </span>
                    </button>
                  </mat-menu>
                </span>
              </div>
              } @if ((existingUser.type == 'SHARED' || existingUser.owner_type === 'share') && existingUser?.owner_type != 'creator') {
              <div class="app__form--attribute--title app__centered-item justify-between text-[10px] m-0 mr-0 relative" style="z-index: 1111111">
                <share-type-control
                  [showShareTypeOptions]="true"
                  sharedToFirstName="{{ existingUser.user_first_name }}"
                  existingShareDetails="{{ setShareDetails(existingUser) | json }}"
                  (onUpdate)="updateExistingUser($event, existingUser)"
                  (onDelete)="deleteExistingUser($event)"
                  sharedObjectType="file"
                  sharedToProfileImage="{{ existingUser.user_profile_image_url }}"
                  sharedToLastName="{{ existingUser.user_last_name }}"
                  [existingUserData]="existingUser"
                  [generalPermission]="this.data.generalPermission"
                ></share-type-control>
              </div>
              }
            </div>
          </div>
        </span>
        }
      </div>
    </div>
    } @if (data?.showMarkAsComplete) {
    <div
      class="app__centered-item w-full min-h-[86px] mt-3"
      [class]="!inlineComponent ? 'absolute bottom-0 text-center px-[52px] py-7' : 'items-start text-start mt-5'"
    >
      <div class="w-full">
        @if (!inlineComponent) {
        <hr class="w-full m-0 mb-4 py-0" style="border: 0.1px solid #c1c2c5" />
        }
        <span class="app__form--attribute--title font-normal text-sm leading-[21px]">
          <span> <mat-slide-toggle (change)="onChange()" [checked]="markSharingAsComplete"></mat-slide-toggle></span>
          Mark Permissions as complete for this template
        </span>
      </div>
    </div>
    }
  </div>
</div>
